<template>
    <b-card>
        <h2 class="pl-1">Клиент </h2>
        <b-row>
            <b-col cols="12" md="6" class="px-1">
                <b-form-group label="Имя" label-for="client-first-name">
                    <b-form-input v-model="client.first_name" id="client-first-name" size="md" readonly />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="px-1">
                <b-form-group label="Фамилия" label-for="client-last-name">
                    <b-form-input v-model="client.last_name" id="client-last-name" size="md" readonly />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="px-1">
                <b-form-group label="Телефон" label-for="client-phone">
                    <b-form-input v-model="client.phone" id="client-phone" size="md" readonly />
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6" class="px-1">
                <b-form-group label="Баланс" label-for="client-balance">
                    <b-form-input
                        v-model.number="editForm.balance"
                        id="client-balance"
                        size="md"
                        type="number"
                        :readonly="!isUpdateAvailable || isSaving"
                    />
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6" class="px-1">
                <b-form-group label="Статус" label-for="client-active">
                    <b-form-checkbox
                        v-model="editForm.active"
                        id="client-active"
                        switch
                        :disabled="!isUpdateAvailable || isSaving"
                    >
                        {{ editForm.active ? "Активен" : "Не активен" }}
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-if="isUpdateAvailable">
            <b-col cols="12" class="px-1">
                <b-button
                    variant="success"
                    class="float-right mt-1"
                    :disabled="isSaving"
                    @click="saveClient"
                >
                    Сохранить
                </b-button>
            </b-col>
        </b-row>

        <h2 class="pl-1 mt-3">Транзакции </h2>
        <b-row>
            <b-col cols="12">
                <b-table striped hover responsive sort-icon-left :busy="isBusy" :items="client.wallet.transactions"
                    :fields="fields">
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong class="ml-1">Идет загрузка ...</strong>
                        </div>
                    </template>

                    <template #cell(active)="data">
                        <span v-if="data.item.active">Активен</span>
                        <span v-else>Не активен</span>
                    </template>

                    <template #cell(created_at)="data">
                        <span>{{
                        new Date(data.item.created_at).toLocaleDateString("ru")
                            }}</span>
                    </template>
                </b-table>
            </b-col>
        </b-row>

    </b-card>
</template>

<script>
import {
    BTable,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BSpinner,
    BCard,
    BFormCheckbox,
} from "bootstrap-vue";
import Transactions from "@/services/transactions";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionComputeds from "@/util/permissionComputeds";
const tapi = new Transactions();

export default {
    name: "AppClientView",
    components: {
        BCard,
        BTable,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BButton,
        BSpinner,
        BFormCheckbox,
        ToastificationContent,
    },
    directives: {
        Ripple,
    },
    data() {
        return {
            isBusy: false,
            isSaving: false,
            fields: [
                {
                    key: "id",
                    label: "ID",
                },
                {
                    key: "amount",
                    label: "Сумма",
                },
                {
                    key: "type",
                    label: "Тип",
                },
                {
                    key: "status",
                    label: "Статус",
                },
                {
                    key: "created_at",
                    label: "Дата создания",
                },
            ],
            client: {
                first_name: '',
                last_name: '',
                phone: '',
                active: false,
                wallet: {
                    balance: 0,
                    transactions: [],
                }
            },
            editForm: {
                balance: null,
                active: false,
            },
        };
    },

    async mounted() {
        await this.fetchClient();
    },

    computed: {
        ...permissionComputeds("client"),
    },

    methods: {
        showToast(variant, text, icon) {
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: text,
                    icon: icon,
                    variant,
                },
            });
        },

        async fetchClient() {
            this.isBusy = true;
            await tapi.fetchClient(this.$route.params.id)
                .then((res) => {
                    const wallet = res.data.wallet || {};
                    this.client = {
                        ...res.data,
                        wallet: {
                            transactions: [],
                            balance: 0,
                            ...wallet,
                        },
                    };
                    this.editForm = {
                        balance: this.client.wallet.balance,
                        active: Boolean(this.client.active),
                    };
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast("danger", "Что-то пошло не так!", "XIcon");
                })
                .finally(() => {
                    this.isBusy = false;
                });
        },

        saveClient() {
            const balance = this.editForm.balance === "" || this.editForm.balance === null
                ? null
                : Number(this.editForm.balance);

            if (balance !== null && !Number.isInteger(balance)) {
                this.showToast("danger", "Баланс должен быть целым числом!", "XIcon");
                return;
            }

            this.isSaving = true;
            tapi.updateClient(this.$route.params.id, {
                balance,
                active: Boolean(this.editForm.active),
            })
                .then(async () => {
                    this.showToast("success", "Успешно cохранено!", "CheckIcon");
                    await this.fetchClient();
                })
                .catch((error) => {
                    console.error(error);
                    this.showToast("danger", "Что-то пошло не так!", "XIcon");
                })
                .finally(() => {
                    this.isSaving = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
[dir] .dropdown-item {
    padding: 0;
}

//::v-deep .table thead th[aria-colindex="1"] {
//  width: 70px;
//}

.validation__red {
    color: red;
    font-size: 12px;
    display: block;
    margin-bottom: 1rem;
}

.form-group {
    margin-bottom: 6px;
}
</style>
